import { t } from '@sm/intl';
export const THEME_MIN_LENGTH = 3;
export const THEME_MAX_LENGTH = 25;
export const KW_MAX_LENGTH = 128;
const INVALID_KEYWORDS = ['', ',', ' '];
export const COPY = {
  malformed: {
    id: 'OpenEndedCoding.errors.malformed',
    defaultMessage: 'You can only use letters and numbers in a theme name.',
    description: '[Type: Label][Vis: med] - OEC malformed input error message'
  },
  duplicates: {
    id: 'OpenEndedCoding.errors.duplicates',
    defaultMessage: '{ themeName } already exists.',
    description: '[Type: Label][Vis: med] - OEC duplicate themes error message'
  },
  length: {
    id: 'OpenEndedCoding.errors.length',
    defaultMessage: 'Please create a theme name that is between { minLength } and { maxLength } characters.',
    description: '[Type: Label][Vis: med] - OEC theme name length error message'
  },
  keywordsHasInvalid: {
    id: 'OpenEndedCoding.errors.keywordsHasInvalid',
    defaultMessage: 'You can only use letters and numbers in a keyword.',
    description: '[Type: Label][Vis: med] - OEC malformed input error message'
  },
  keywordsHasDuplicates: {
    id: 'OpenEndedCoding.errors.keywordsHasDuplicates',
    defaultMessage: 'There are some duplicate keywords.',
    description: '[Type: Label][Vis: med] - OEC duplicate keywords'
  },
  keywordsTooLong: {
    id: 'OpenEndedCoding.errors.keywordsTooLong',
    defaultMessage: 'Please create a keyword that is less than { maxLength } characters.',
    description: '[Type: Label][Vis: med] - OEC keyword length error message'
  },
  keywordsNotEnough: {
    id: 'OpenEndedCoding.errors.keywordsTooLong',
    defaultMessage: 'Please create at least one keyword per theme.',
    description: '[Type: Label][Vis: med] - OEC keyword minimum required error message'
  }
};
export const NO_ERRORS = {
  error: false,
  messages: []
};
// we only allow letters, numbers and spaces for theme names
export const onlyLettersAndNumbers = str => {
  return /^[a-zA-ZÀ-ÖØ-öø-ÿ0-9\s]*$/.test(str);
};
export const validateTheme = ({
  themes,
  themeName,
  originalTheme = ''
}) => {
  const errors = {
    error: false,
    messages: []
  };
  // check length
  if (themeName.length < THEME_MIN_LENGTH || themeName.length > THEME_MAX_LENGTH) {
    errors.error = true;
    errors.messages.push(t(COPY.length, {
      minLength: THEME_MIN_LENGTH,
      maxLength: THEME_MAX_LENGTH
    }));
  }
  // check for malformed input
  const malformed = !onlyLettersAndNumbers(themeName);
  if (malformed) {
    errors.error = true;
    errors.messages.push(t(COPY.malformed));
  }
  // check for duplicates
  const duplicates = themes.filter(({
    theme
  }) => theme.toLowerCase() === themeName.toLowerCase() && theme !== originalTheme);
  if (duplicates.length > 0) {
    errors.error = true;
    errors.messages.push(t(COPY.duplicates, {
      themeName
    }));
  }
  return errors;
};
export const hasDuplicates = ({
  items
}) => {
  const lowerCaseItems = items.map(item => item.toLowerCase());
  return lowerCaseItems.some((item, index) => lowerCaseItems.indexOf(item) !== index);
};
export const buildKeywordsErrorMessages = errors => {
  const messages = [];
  if (errors.keywordsHasInvalid) {
    messages.push(t(COPY.keywordsHasInvalid));
  }
  if (errors.keywordsTooLong) {
    messages.push(t(COPY.keywordsTooLong, {
      maxLength: KW_MAX_LENGTH
    }));
  }
  if (errors.keywordsHasDuplicates) {
    messages.push(t(COPY.keywordsHasDuplicates));
  }
  if (errors.keywordsNotEnough) {
    messages.push(t(COPY.keywordsNotEnough));
  }
  return messages;
};
export const validateKeywords = ({
  keywords
}) => keywords.map(k => {
  // track different types of errors
  const errors = {
    keywordsHasInvalid: false,
    keywordsHasDuplicates: false,
    keywordsTooLong: false,
    keywordsNotEnough: false
  };
  // remove all spaces, split by comma and replace empties
  const keywordList = k.keywords.split(',').filter(kw => kw.trim() !== '');
  if (keywordList.length === 0) {
    errors.keywordsNotEnough = true;
  }
  keywordList.forEach(keyword => {
    // can't have any invalid keywords
    // can only have letters, numbers and spaces
    if (INVALID_KEYWORDS.includes(keyword) || !onlyLettersAndNumbers(keyword)) {
      errors.keywordsHasInvalid = true;
    }
    // can't create long keywords
    if (keyword.length > KW_MAX_LENGTH) {
      errors.keywordsTooLong = true;
    }
  });
  // check for duplicates in keywords list
  if (hasDuplicates({
    items: keywordList
  })) {
    errors.keywordsHasDuplicates = true;
  }
  // build errors
  const error = Object.values(errors).some(e => e);
  const errorMessages = buildKeywordsErrorMessages(errors);
  return {
    themeId: k.themeId,
    keywords: keywordList.join(','),
    error,
    errorMessages
  };
});